import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from "moment-timezone";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SharedService {
  static PREVIEW_SUPPORT_COOKIE = 'preview_support';
  static CURRENT_VTUBER = 'current_vtuber';
  static CURRENT_SUPPORT_PLAN = 'current_support_plan';
  static CURRENT_CHAT = 'current_chat';
  static CURRENT_RESERVE = 'current_reserve';
  static CURRENT_CANCEL_RESERVE = 'current_cancel_reserve';

  static LAER_WELCOME_MESSAGE = "LAERのご利用ありがとうございます。"

  // static LAER_USER_WELCOME = "Laerへようこそ！<br/>まずはこちらからクリエイターを探して、支援を始めてみましょう 🌸 <br/><br/>- クリエイターを見つける <br/><a href='" + environment.site_url + "/user/vtubers'>" + environment.site_url + "/user/vtubers</a> "
  static LAER_USER_WELCOME = "Laerへようこそ！<br/>まずは<a href='" + environment.site_url + "/user/vtubers'>こちら</a>からクリエイターを探して、支援を始めてみましょう 🌸 <br/><br/>レアの詳しい使い方については<a href='https://drive.google.com/file/d/1PjsxggBHjR23zHaqijWJEnbphs64igfF/view?usp=sharing' target='_blank'>ユーザーガイド</a>を御覧ください。"
  static LAER_VTUBER_MESSAGE = "Laerへようこそ！<br/>まずは<a href='" + environment.site_url + "/vtuber/support'>こちら</a>から支援ページを作成してみましょう🌸 <br/><br/>レアの詳しい使い方については<a href='https://drive.google.com/file/d/1xbzAvcds8TF6Y2R1vxXjf6kizt5jRNs6/view?usp=sharing' target='_blank'>ユーザーガイド</a>を御覧ください。"

  constructor(
    private router: Router
  ) {

  }

  setCookie(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
  }

  removeCookie(key) {
    window.localStorage.removeItem(key)
  }

  getCookie(key) {
    return window.localStorage.getItem(key) ? JSON.parse(window.localStorage.getItem(key)) : undefined
  }

  getReserveTime(info) {
    return moment(info.reserveAt).format("YYYY年MM月DD日 ") + info.start + " ~ " + info.end
  }

  redirect(url, isNewTab = false) {
    if (isNewTab) {
      let newUrl = this.router.createUrlTree([url])
      window.open(newUrl.toString(), '_blank')
    } else {
      this.router.navigate([url]);
    }
  }

  public static validBankNumber(value) {
    const regex = /^[0-9]{7,18}$/g;
    return regex.test(value)
  }

  public static validEnglishLetter(value) {
    return /^[a-zA-Z ]*$/.test(value)
  }
}
